module.exports = __webpack_public_path__ + "static/media/mmc-ireland.45ae0c8b.png";